import SpineWrapper from '@Core/Animation/SpineWrapper';
import { ELayeringOrder } from '@GFTypes/LayeringOrder';
import { GameScene } from '..';

export class BaseWinPresentationSpine {
    public static readonly SPINE_KEY = 'wins';
    public static readonly SKIN_NAME = 'default';
    public static readonly ODOMETER_SLOT_NAME = 'bigwin_odometer_placeholder';
    public spineWrapper: SpineWrapper;

    constructor(scene: GameScene) {
        this.spineWrapper = new SpineWrapper(
            scene,
            {
                x: scene.screen.width / 2,
                y: scene.screen.height / 2
            },
            { dataKey: BaseWinPresentationSpine.SPINE_KEY, skinName: BaseWinPresentationSpine.SKIN_NAME },
            true
        );
        this.spineWrapper.spine.zIndex = ELayeringOrder.WIN;
    }
}
